import OriginalAvatar from './Avatar.svelte';
import Indicator from './Indicator.svelte';
import Placeholder from './Placeholder.svelte';
const Avatar = OriginalAvatar;
Avatar.Indicator = Indicator;
Avatar.Placeholder = Placeholder;
export default Avatar;
